import axios from 'axios'
import Cookies from 'universal-cookie'
import ConfigResolver from './ConfigResolver'
// import { sendDiscordError } from '../utils'


const config = ConfigResolver.config()
const cookies = new Cookies()

const requestHandler = (request) => {
  // Django API uses legacy JWT tokens from sessionStorage
  request.headers['Authorization'] = `JWT ${sessionStorage.getItem('token')}`
  return request
}

const errorHandler = (error) => {
  console.log(error)
  // sendDiscordError('Submissions Server', error.message, error.url)
  return Promise.reject({ ...error })
}

const successHandler = (response) => {
  return response
}

const axiosInstance = axios.create({
  baseURL: `${config.apiEndpoint}/${config.apiVersion}`
})

axiosInstance.interceptors.request.use(
  request => {
    return requestHandler(request)
  }
)

axiosInstance.interceptors.response.use(
  response => {
    return successHandler(response)
  }, 
  error => {
    return errorHandler(error)
  }
)

// WordPress API instance — includes Auth0 token for authenticated WP API calls
const wpAxios = axios.create()

wpAxios.interceptors.request.use(
  request => {
    const cookieToken = cookies.get('smp_access_token')
    if (cookieToken) {
      request.headers['Authorization'] = `Bearer ${cookieToken}`
    } else {
      const sessionToken = sessionStorage.getItem('token')
      if (sessionToken) {
        request.headers['Authorization'] = `Bearer ${sessionToken}`
      }
    }
    return request
  }
)

wpAxios.interceptors.response.use(
  response => successHandler(response),
  error => errorHandler(error)
)

export { wpAxios }
export default axiosInstance

